<template>
  <div class="whole_company_from">
    <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline">
      <QS-search maxLine="2">
        <el-form-item prop="serviceId" label="服务商名称(ID)">
          <el-select
            v-model="formInline.serviceId"
            filterable
            remote
            clearable
            placeholder="请输入关键词"
            :remote-method="loadProviderData"
            :loading="loading"
            @visible-change="
              (e) => {
                changeValue(e, 'serviceProvider')
              }
            "
          >
            <el-option
              v-for="item in providerData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="合作状态">
          <el-select
            v-model="formInline.collaborationState"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in selectColumns.collaborationStateSelectColums"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态">
          <el-select v-model="formInline.auditState" placeholder="请选择" clearable
            filterable>
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in selectColumns.auditStateSelectColums"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="最新审核内容">
          <el-select v-model="formInline.auditContent" placeholder="请选择" clearable
            filterable>
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in selectColumns.auditContentSelectColums"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <template slot="moreBtn">
          <div class="moreBtn-wrapper">
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="search"
                :loading="searchLoading"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button @click="reset" size="small">重置</el-button>
            </el-form-item>
          </div>
        </template>
      </QS-search>
    </el-form>
    <QS-common-table
      :data="tableData"
      :columns="maintenanceReviewColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
    />

    <store-list-dialog
      :dialogVisible="storeDialogVisible"
      @close="storeDialogVisible = false"
      :id="storeId"
    />

    <project-list-dialog
      :dialogVisible="projectDialogVisible"
      @close="projectDialogVisible = false"
      :id="projectId"
    />
  </div>
</template>

<script>
import config from '../config'
import storeListDialog from '../components/storeListDialog.vue'
import projectListDialog from '../components/projectListDialog.vue'
// eslint-disable-next-line import/no-cycle
import { providerList } from '@/api/domain/carsService'
import { collaborationPageList } from '../services'
import { debounce } from '@/utils'

export default {
  name: 'maintenanceReview',
  components: {
    storeListDialog,
    projectListDialog,
  },
  data() {
    const { maintenanceReviewColumns, selectColumns } = config.call(this)
    return {
      loading: false,
      formInline: {},
      providerData: [],
      tableData: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      searchLoading: false,
      maintenanceReviewColumns,
      storeDialogVisible: false,
      projectDialogVisible: false,
      selectColumns,
      storeId: 0,
      projectId: 0,
    }
  },
  methods: {
    // 搜索服务商名称(性能问题)
    async loadProviderData(query) {
      this.loading = true
      const [err, _data] = await this.$to(providerList({ name: query }))
      if (err) return
      const { code } = _data
      let { data } = _data
      if (code === 1) {
        this.loading = false
        if (!data) {
          data = {}
        } else if (!Array.isArray(data.items)) {
          data.items = []
        }

        this.providerData = data.items.map((item) => ({ ...item, name: `${item.name}(${item.id})` }))
      }
    },
    changeValue(e, str) {
      if (str === 'serviceProvider') {
        if (!e) {
          this.providerData = []
        }
      }
    },
    // 获取table数据
    async getCollaborationPageList(params) {
      const { code, data } = await collaborationPageList({
        ...params,
        ...this.formInline,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      })

      if (code === 1 && data) {
        this.searchLoading = false
        this.paginationData.total = data.totalNum
        this.tableData = data.items
      } else {
        this.searchLoading = false
      }
    },
    // 查询
    search: debounce(async function () {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.searchLoading = true
      this.getCollaborationPageList()
    }, 500),
    // 重置
    reset() {
      this.$refs.formInline.resetFields()
      Object.keys(this.formInline).forEach((item) => {
        this.formInline[item] = ''
      })
      this.search()
    },
    // 分页
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getCollaborationPageList()
    },
    // 打开详情页
    // eslint-disable-next-line vue/no-unused-properties
    openDetailPage(row) {
      this.$router.push({
        path: '/purchaseNew/maintenanceReview/list_detail',
        query: {
          id: row.id,
        },
      })
    },
    // 门店列表
    // eslint-disable-next-line vue/no-unused-properties
    openStoreListDialog(row) {
      this.storeId = row.id
      this.storeDialogVisible = true
    },
    // 项目列表
    // eslint-disable-next-line vue/no-unused-properties
    openProjectListDialog(row) {
      this.projectId = row.id
      this.projectDialogVisible = true
    },
  },
  created() {
    this.getCollaborationPageList(this.$route.query || {})
  },
}
</script>
